import React from 'react'
import images from '../../../config/images'
import { ALertHeaderText } from '../../../components/Seminars/styles'
import FlatButton from 'material-ui/FlatButton'
import { FormattedMessage } from 'react-intl'

const UpGradeDegradeComplete = props =>
  <div>
    <div className="flex justify-center items-center mb4">
      <ALertHeaderText>
        <FormattedMessage id="plan.successChangedPlan" />
      </ALertHeaderText>
    </div>
    <div className="flex justify-center mb4">
      <img src={images.successImage} alt="congrats"/>
    </div>
    <div className="flex justify-center">
      <FlatButton
        label={<FormattedMessage id="plan.moveOn" />}
        hoverColor="#1e8257"
        backgroundColor="#29B87A"
        labelStyle={{color: '#FFFFFF'}}
        onTouchTap={props.handleClose}
      />
    </div>
  </div>

export default UpGradeDegradeComplete


// WEBPACK FOOTER //
// src/routes/ManagePlans/Plans/UpGradeDegradeComplete.js